module.exports = __webpack_public_path__ + "img/4.417b1cc3.png";